var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',[_c('a',{attrs:{"href":"http://ykpianoforte.com/en.php","target":"_blank"}},[_vm._v(" © 株式会社 "),_c('span',[_vm._v("演")])])])])}]

export { render, staticRenderFns }